const titleDataEN = {
  aboutme: "About Me",
  technologies: "Technologies",
  experience: "Experience",
  projects: "Projects",
};

const titleDataGR = {
  aboutme: "Σχετικά με Εμένα",
  technologies: "Τεχνολογίες",
  experience: "Εμπειρία",
  projects: "Πρότζεκτ",
};

export { titleDataEN, titleDataGR };
